"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
import useDeviceInfo from "../../../../hooks/useDeviceInfo";
type IconComp = React.ComponentType<{
  className?: string;
}>;
interface SidebarPrimaryItemProps {
  readonly href?: string;
  readonly onClick?: (e?: React.MouseEvent) => void;
  readonly icon?: IconComp;
  readonly iconSizeClass?: string;
  readonly label: string;
  readonly active?: boolean;
  readonly collapsed?: boolean;
  readonly ariaExpanded?: boolean;
  readonly ariaControls?: string;
  readonly rightSlot?: React.ReactNode;
  readonly hasIndicator?: boolean;
  readonly "data-section"?: string;
}
function WebSidebarNavItem(t0) {
  const $ = _c(39);
  const {
    href,
    onClick,
    icon: Icon,
    iconSizeClass,
    label,
    active,
    collapsed,
    ariaExpanded,
    ariaControls,
    rightSlot,
    hasIndicator,
    "data-section": dataSection
  } = t0;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  const t1 = `tw-flex tw-items-center tw-w-full tw-h-full ${collapsed ? "" : "tw-gap-x-2"}`;
  let t2;
  if ($[0] !== Icon || $[1] !== hasIndicator || $[2] !== iconSizeClass) {
    t2 = Icon && <div className="tw-relative"><Icon aria-hidden="true" className={`tw-h-6 tw-w-6 tw-flex-shrink-0 ${iconSizeClass ?? ""}`} />{hasIndicator && <><div className="tw-flex-shrink-0 tw-absolute tw-right-0 tw-top-0 tw-rounded-full tw-bg-red tw-h-2 tw-w-2" /><span className="tw-sr-only">Unread</span></>}</div>;
    $[0] = Icon;
    $[1] = hasIndicator;
    $[2] = iconSizeClass;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="tw-w-10 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `tw-block tw-overflow-hidden tw-whitespace-nowrap tw-transition-all tw-duration-300 motion-reduce:tw-transition-none ${collapsed ? "tw-opacity-0 tw-w-0" : "tw-opacity-100 tw-flex-1"}`;
  let t5;
  if ($[6] !== label || $[7] !== t4) {
    t5 = <span className={t4}>{label}</span>;
    $[6] = label;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !collapsed && rightSlot;
  let t7;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t5 || $[12] !== t6) {
    t7 = <div className={t1}>{t3}{t5}{t6}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const content = t7;
  const t8 = collapsed ? label : undefined;
  let t9;
  if ($[14] !== collapsed || $[15] !== hasTouchScreen || $[16] !== label) {
    t9 = !hasTouchScreen && {
      "data-tooltip-id": "sidebar-tooltip",
      "data-tooltip-content": label,
      "data-tooltip-hidden": !collapsed
    };
    $[14] = collapsed;
    $[15] = hasTouchScreen;
    $[16] = label;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== dataSection) {
    t10 = dataSection ? {
      "data-section": dataSection
    } : {};
    $[18] = dataSection;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t8 || $[22] !== t9) {
    t11 = {
      "aria-label": t8,
      ...t9,
      ...t10
    };
    $[20] = t10;
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const commonProps = t11 as const;
  if (href) {
    const t12 = `tw-w-full tw-block tw-no-underline tw-rounded-xl tw-border-none tw-transition-colors tw-duration-200 motion-reduce:tw-transition-none tw-h-[2.875rem] tw-cursor-pointer focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-iron-500 focus-visible:tw-ring-offset-2 tw-font-medium tw-text-base tw-px-2 tw-touch-action-manipulation ${active ? "tw-text-white tw-bg-transparent desktop-hover:hover:tw-bg-transparent desktop-hover:hover:tw-text-white active:tw-text-white" : "tw-text-iron-400 tw-bg-transparent desktop-hover:hover:tw-bg-transparent desktop-hover:hover:tw-text-white active:tw-text-white"}`;
    const t13 = active ? "page" : undefined;
    let t14;
    if ($[24] !== commonProps || $[25] !== content || $[26] !== href || $[27] !== t12 || $[28] !== t13) {
      t14 = <Link href={href} className={t12} aria-current={t13} {...commonProps}>{content}</Link>;
      $[24] = commonProps;
      $[25] = content;
      $[26] = href;
      $[27] = t12;
      $[28] = t13;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    return t14;
  }
  let t12;
  if ($[30] !== onClick) {
    t12 = e => onClick?.(e);
    $[30] = onClick;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  const t13 = `tw-w-full tw-block tw-text-left tw-no-underline tw-rounded-xl tw-border-none tw-transition-colors tw-duration-200 motion-reduce:tw-transition-none tw-h-[2.875rem] tw-cursor-pointer focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-iron-500 focus-visible:tw-ring-offset-2 tw-font-medium tw-text-base tw-px-2 tw-touch-action-manipulation tw-bg-transparent ${active ? "tw-text-white tw-bg-transparent desktop-hover:hover:tw-bg-transparent desktop-hover:hover:tw-text-white active:tw-text-white" : "tw-text-iron-400 tw-bg-transparent desktop-hover:hover:tw-bg-transparent desktop-hover:hover:tw-text-white active:tw-text-white"}`;
  let t14;
  if ($[32] !== ariaControls || $[33] !== ariaExpanded || $[34] !== commonProps || $[35] !== content || $[36] !== t12 || $[37] !== t13) {
    t14 = <button type="button" onClick={t12} className={t13} aria-expanded={ariaExpanded} aria-controls={ariaControls} {...commonProps}>{content}</button>;
    $[32] = ariaControls;
    $[33] = ariaExpanded;
    $[34] = commonProps;
    $[35] = content;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
}
export default React.memo(WebSidebarNavItem);